import type { TimeDifference } from '@/shared/lib/date/getTimeDifference';
import { useAppSelector } from '@/store/hooks';

const useTimeToExpire = (): TimeDifference | undefined =>
  useAppSelector(state => state.user.timeToExpire);

export default useTimeToExpire;
